var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h2',{staticClass:"header-medium"},[_vm._t("default"),_vm._v(" "+_vm._s(_vm.$t('stepper.header', [_vm.currentStep + 1, _vm.numSteps]))+" ")],2)}
var staticRenderFns = []

export { render, staticRenderFns }